import type { FaireProductEntity } from "../../entity_types/product";

export const p_87as42nczh: FaireProductEntity = {
  token: "p_87as42nczh",
  type: "product",
  name: "Soothe Gentle Dog Shampoo",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/77f27bf9c53b61bf5fe8c9c32fa4b51ff2e22d8d887f77b9c5be6510880af39d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8fb92534e726548c4309d1a0ebf94889a0030655795a40396f16aa6d63a21de8.jpeg",
    "https://cdn.faire.com/fastly/61f71230a398978c73f598d0ac6a5c1fce571ffb3ad1d9784824f5390af2f9ee.jpeg",
    "https://cdn.faire.com/fastly/5799163d0312da83138d6b61e0f8a8418c5ab1f17af3459b43f10596fe40b2c2.png"
  ],
  priceDollars: 12.5,
  description: "The bath day upgrade for dogs with sensitive skin.\n\nWhy we love it: A gentle deep cleanse that soothes itchy skin without drying out your dog's coat.\n\nVet-Dermatologist Approved | Fragrance-Free | pH-Balanced for Dogs | Lick-Safe | Vegan | Cruelty-Free\n",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:37.619Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
